import {getTenantHostName} from "./TenantService.js";

const setOrgName = async () => {
  const tenantConfig = await getTenantHostName();
  document.getElementById("org-name-span").innerText =
    tenantConfig.organizationShortName + " for more details";
};

setOrgName();
